import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface UpdateInvestmentStatusPayload {
  uuid: string;
  status: "active" | "withdrawn" | "hidden";
}

export const useUpdateInvestmentStatus = (
  options?: UseMutationOptions<any, Error, UpdateInvestmentStatusPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateInvestmentStatus"],
    mutationFn: async ({ uuid, status }: UpdateInvestmentStatusPayload) => {
      return axiosInstance
        .patch(`/investments/${uuid}/status`, { status })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa zmiana statusu aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-investment-status",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Status aktywa zaktualizowany.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-investment-status",
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      queryClient.invalidateQueries({ queryKey: ["investments/admin/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas zmiany statusu aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-investment-status",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateInvestmentStatus;
